import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import { Avatar, Typography } from "@mui/material";
import styled from "styled-components";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import logo from "../../assets/img/LogoMenu.png";
import italy from "../../assets/img/Italy.png";
import { I18n, LOCALES } from "../../i18n";
import { importBaseActions } from "../../store/reducers/base";

const TopBarMinimal = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const store = useSelector((state) => state.base);
  const baseActions = importBaseActions();

  const getInitials = () => {
    const { firstName, lastName } = store.user;
    return `${firstName?.[0] || ""}${lastName?.[0] || ""}`;
  };

  return (
    <I18n locale={store.locale}>
      <TopbarResponsive sx={{ flexGrow: 1 }}>
        <AppBar position="static">
          <Toolbar className="justify-content-between">
            {/* LOGO SINISTRA */}
            <Box sx={{ display: "flex", alignItems: "center", cursor: "pointer" }} onClick={() => navigate("/")}> 
              <img src={logo} alt="logo" />
            </Box>

            {/* UTENTE + BANDIERA DESTRA */}
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Box sx={{ display: "flex", alignItems: "center", mr: 2 }}>
                <Avatar
                  src={store.user.logo || undefined}
                  sx={{ mr: 1, width: "2.5rem", height: "2.5rem" }}
                  className="bg-dark text-white"
                >
                  {!store.user.logo && getInitials()}
                </Avatar>
                <Typography sx={{ lineHeight: 1.1 }}>
                  <strong>
                    {store.user.firstName} {store.user.lastName}
                  </strong>
                  <br />
                  <small>{store.user.code}</small>
                </Typography>
              </Box>

              <img
                src={italy}
                alt="it"
                style={{ cursor: "pointer" }}
                onClick={() => dispatch(baseActions.setLocale(LOCALES.ITALIAN))}
              />
            </Box>
          </Toolbar>
        </AppBar>
      </TopbarResponsive>
    </I18n>
  );
};

export default TopBarMinimal;

const TopbarResponsive = styled(Box)`
  width: 100%;
`;
